import React from 'react';

type Segment = {
  porcentaje: number;
  color: string;
};

type Props = {
  segments: Segment[];
};

const ProgressProduct: React.FC<Props> = ({ segments }) => {
  return (
    <div
      style={{
        display: 'flex',
        height: '8px',
        width: '100%',
        overflow: 'hidden',
        borderRadius: '4px',
        backgroundColor: '#eee',
      }}
    >
      {segments.map((segment, index) => (
        <div
          key={index}
          style={{
            width: `${segment.porcentaje}%`,
            backgroundColor: segment.color,
            height: '100%',
          }}
        />
      ))}
    </div>
  );
};

export { ProgressProduct };
